import gql from 'graphql-tag';

interface PlantingEventAggregatesVariables {
  fieldUUID: string;
}

export const getPlantingEventAggregates = (variables: PlantingEventAggregatesVariables) => ({
  query: gql`
  query PlantingEventAggregates($fieldUUID: ID!) {
    field(id: $fieldUUID) {
      id
      plantingAnalytics {
        plantingEventsAggregate(emergentStatus: true) {
          averageSeedPopulation
          plantingDate
          seasonCode
          seedProductId
          seedProduct {
            __typename
            id
            name
          }
          totalPlantedArea
        }
      }
    }
  }
  `,
  variables,
});
